import React from 'react'
import { useParams } from 'react-router-dom'

const Logo: React.FC = () => {
  const { iconName } = useParams<{ iconName: string }>()

  if (!iconName) {
    return <div>No icon provided</div>
  }

  let iconSrc: string

  try {
    iconSrc = require(`../assets/${iconName}`)
  } catch (err) {
    console.error(`Image not found: ${iconName}`)
    return <div>Image not found</div>
  }

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <img
        src={iconSrc}
        alt={iconName}
        style={{ maxWidth: '200px', height: 'auto' }}
      />
    </div>
  )
}

export default Logo
